import { createSelector } from 'reselect'

import { selectCockpitPartnerData } from './selectCockpitPartnerData'

export const selectCockpitRtmCounts = createSelector([selectCockpitPartnerData], (partnerData) => ({
  resellersCount: partnerData.filter((partner) => partner.IsCommercial === 1).length,
  distributorsCount: partnerData.filter((partner) => partner.IsDistributor === 1).length,
}))
